import currenttabreducer from './currenttabreducer'
import {combineReducers} from 'redux'

const rootreducer=combineReducers({
    currenttab:currenttabreducer
})

export default rootreducer